import React, { ReactNode } from 'react';
import { Body, Flex } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

type PrimeMessageType = {
  PriceDescription: ReactNode;
};

const PrimeMessage: React.FC<PrimeMessageType> = ({ PriceDescription }) => {
  const { t } = useTranslation();
  const lineHeightNormalSx = { lineHeight: 'normal' };

  return (
    <>
      <Flex flexDirection="row" justifyContent="flex-end">
        <Flex flexDirection="column" justifyContent={'flex-end'}>
          <Body
            color="brandPrimary.1"
            type={'xSmall'}
            weight={'medium'}
            sx={lineHeightNormalSx}
          >
            {t('prime.switch.label')}
          </Body>
          <Body
            color="neutral.70"
            type={'xxSmall'}
            weight={'normal'}
            sx={lineHeightNormalSx}
          >
            {t('results.passengers.details')}
          </Body>
          <Body color="neutral.80" type="xxSmall" sx={lineHeightNormalSx}>
            {PriceDescription}
          </Body>
        </Flex>
      </Flex>
    </>
  );
};

export default PrimeMessage;
